export default {"src":"/_next/static/media/check_white.304e0741.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};